import Vue from "vue";
import VueRouter from "vue-router";


import Landing2 from '../views/frontpage/Landing2'
import Companies from '../views/frontpage/Companies'
import Volunteers from '../views/frontpage/Volunteers'
import NotFound from "../views/NotFound.vue";


Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Početna",
    component: Landing2,
  },
  {
    path: "/kompanije",
    name: "Kompanije",
    component: Companies,
  },
  {
    path: "/volontiraj",
    name: "Volonteri",
    component: Volunteers,
    beforeEnter() {
      // Put the full page url including the protocol http(s) below
      window.open('https://budivolonter.gov.rs/', '_blank');
    }
  },
  {
    path: "*",
    name: "Stranica nije pronadjena",
    component: NotFound,
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
